/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import _ from 'underscore';

import { Spinner } from '../../../common/spinner';
import { ShippingStore } from '../../../stores/ShippingStore';
import { CheckoutStore } from '../../../stores/CheckoutStore';
import { ShippingRadio } from '../shipping-radio';
import styles from './ShippingSection.css';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';

const IPropTypes = {
  onSelection: PropTypes.func,
};

const defaultProps = {
  onSelection: () => {},
};

class ShippingSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null,
    };

    this._onRadioSelection = this._onRadioSelection.bind(this);
    this._transformShippingOption = this._transformShippingOption.bind(this);
    this._filterOutSaturdayAfternoon = this._filterOutSaturdayAfternoon.bind(this);
  }

  componentDidMount() {
    const address = CheckoutStore.selectedAddress;
    const cart = CheckoutStore.checkoutCart;
    let nextDate = null;
    if (ConfigParametersStore.isFeatureFlagEnabled('product_next_deliveries')) {
      const productsNext = ConfigParametersStore.featureFlags.product_next_deliveries.data;
      const productIdInCart = cart.map(item => item.product.id);
      const dates = productIdInCart.filter(item =>
        productsNext[item]).map(item => productsNext[item]);
      dates.sort((a, b) => b.localeCompare(a));
      nextDate = dates.length > 0 ? dates[0] : null;
    }
    if (address && cart) {
      ShippingStore.fetchShippingOptions(cart, address, nextDate);
    }
  }

  _onRadioSelection(option, selectedTimeSlot = null, selectedAgency = null) {
    this.setState({
      selectedOption: option,
    });
    this.props.onSelection(option, selectedTimeSlot, selectedAgency);
  }

  _filterOutSaturdayAfternoon(options) {
    if (!Array.isArray(options)) return [];

    const shouldRemove = (wd, shift) => wd === 6 && shift === 2;

    const out = [];
    for (const item of options) {
      if (!item || typeof item !== 'object') {
        continue;
      }

      if (item.optionType === 'simple') {
        // descartar si es sábado tarde
        if (shouldRemove(item.futureWeekday, item.simpleShift)) {
          continue;
        }
        out.push(item);
        continue;
      }

      if (item.optionType === 'special' && Array.isArray(item.timeSlots)) {
        // mismo formato, pero filtrando los timeSlots
        const keptSlots = item.timeSlots
          .filter(ts => !shouldRemove(ts.futureWeekday, ts.simpleShift));
        out.push({ ...item, timeSlots: keptSlots });
        continue;
      }

      // Otros tipos (agency, etc.) se mantienen tal cual
      out.push(item);
    }

    return out;
  }

  _transformShippingOption() {
    const options = (ShippingStore.shippingOptions ?
      ShippingStore.shippingOptions.filter(item => item !== undefined) : [])
      .map((option) => {
        const newOption = { ...option, newDate: option.date };
        return newOption;
      });
    const optionsAgency = options.filter(option => option.optionType === 'agency');
    const optionsSimple = _(options.filter(option => option.optionType === 'simple'))
      .chain()
      .sortBy(option => new Date(option.date).getTime())
      .value();
    const optionsSpecial = options.filter(option => option.optionType === 'special');
    // console.log(JSON.stringify([...optionsSimple, ...optionsSpecial, ...optionsAgency]));
    return [...optionsSimple, ...optionsSpecial, ...optionsAgency];
  }

  render() {
    const options = this._filterOutSaturdayAfternoon(this._transformShippingOption());

    return (
      <div>
        <h3 className={styles.title}>
          Elija su opción de envío
        </h3>
        <div>
          <h5 className={styles.subtitle}>
            Tipo de envío *
          </h5>
          { ShippingStore.isLoadingShippingOptions &&
            <div>
              <Spinner />
            </div>
          }
          { options &&
            options.map(option => (
              <ShippingRadio
                key={option.id}
                option={option}
                selected={this.state.selectedOption && this.state.selectedOption.id === option.id}
                onClick={this._onRadioSelection}
              />
          ))}
        </div>
      </div>
    );
  }
}

ShippingSection.propTypes = IPropTypes;
ShippingSection.defaultProps = defaultProps;

const ObservedShippingSection = observer(ShippingSection);

export { ObservedShippingSection as ShippingSection };



// WEBPACK FOOTER //
// ./src/pages/shipping-options/shipping-section/ShippingSection.jsx